import { i18n } from 'core/i18n';
import React from 'react';
import { OKButton } from 'components/commons/OKButton/OKButton';
import DocumentsModalFooterPrimaryButton from './DocumentsModalFooterPrimaryButton';

const { formatText } = i18n

export const DocumentsModalFooter = ({
    areAlldocumentsAccepted,
    isCurrentDocumentAcepted,
    isCurrentDocumentRead,
    isSavingDocumentAcceptance,
    onClose,
    onCancel,
    onConfirm,
    onContinue,
    onContinueDisabled,
    currentDocument,

}) => {
    return (
        <div className="documents__modal-buttons">
            <span>
                {isCurrentDocumentAcepted ? (
                    <OKButton onClick={onClose} modifier="link-ghost">
                        <p>{formatText('contractsView-dic_buttonClose')}</p>
                    </OKButton>
                ) : (
                    <OKButton onClick={onCancel} modifier="link-ghost">
                        <p>{formatText('hireCreditCard-cancel')}</p>
                    </OKButton>
                )}
            </span>
            <DocumentsModalFooterPrimaryButton
                isCurrentDocumentRead={isCurrentDocumentRead}
                areAlldocumentsAccepted={areAlldocumentsAccepted}
                isSavingDocumentAcceptance={isSavingDocumentAcceptance}
                onConfirm={onConfirm}
                onContinue={onContinue}
                onContinueDisabled={onContinueDisabled}
                currentDocument={currentDocument}

            />
        </div>
    );
};
